import React from 'react'
import { CompanyCredit } from '../../../../../services/api/companies'
import { Typography } from 'antd'
import { displayAmount, displayDate } from '../../../../../utils/formatter'

const { Text } = Typography
type Props = {
  debt: number
  currency: string
  credit: CompanyCredit
}

export const CreditLine: React.FunctionComponent<Props> = ({
  debt,
  currency,
  credit,
}) => {
  return (
    <Typography>
      <Text>
        Максимальный лимит: {displayAmount(credit.amount)} {currency}
      </Text>
      <br />
      <Text type="secondary">
        {debt > 0 && (
          <div>
            Остаток долга: {displayAmount(debt)} {currency}
          </div>
        )}
        Действует до: {displayDate(credit.expiryDate)}
      </Text>
    </Typography>
  )
}
